var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('BaseCheckbox',{attrs:{"checked":_vm._.get(_vm.tableProps.row, _vm.colInfo.prop, false),"disabled":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }